import { bindAll } from '../../../includes/js/utils'

export class SiteHeader extends HTMLElement {
  constructor() {
    super()

    bindAll(this, [
      'hideNav',
      'showNav',
      'handleKeyboardEvents',
      'handleClickOutside',
      'handleSkipContent',
      'showSearchBar',
      'hideSearchBar',
      'handleSearchToggle',
      'handleFocusOut',
      'handleNavLinkClick',
      'showSubscribe',
      'hideSubscribe',
      'handleSubscribeToggle'
    ])

    this.onSearchPage = false
    this.ui = {
      nav: null,
      container: null,
      skipContentButton: null,
      searchBar: null,
      searchBarToggle: null,
      overlay: null
    }
  }

  connectedCallback() {
    this.ui = {
      nav: this.querySelector('.header__navigation'),
      container: this.querySelector('.header__inner'),
      skipContentButton: this.querySelector('[data-skip-content]'),
      searchBar: this.querySelector('search-bar'),
      newsletterSignup: this.querySelector('newsletter-signup'),
      searchBarToggle: this.querySelector('[data-search-toggle]'),
      subscribeToggle: this.querySelector('[data-subscribe-toggle]'),
      overlay: this.querySelector('.id-site-header-overlay'),
      navLinks: this.querySelectorAll('.header__navigation a')
    }
    this.init()
  }

  disconnectedCallback() {
    this.removeEvents()
  }

  init() {
    this.checkForSearch()
    this.addEvents()
  }

  blockScroll = () => {
    window.addEventListener('scroll', this.preventScroll, { passive: false })
    window.addEventListener('wheel', this.preventScroll, { passive: false })
    window.addEventListener('touchmove', this.preventScrollOutsideSearch, { passive: false })
  }

  enableScroll = () => {
    window.removeEventListener('scroll', this.preventScroll, { passive: false })
    window.removeEventListener('wheel', this.preventScroll, { passive: false })
    window.removeEventListener('touchmove', this.preventScrollOutsideSearch, { passive: false })
  }

  preventScroll = (event) => {
    event.preventDefault()
    event.stopPropagation()
    return false
  }

  preventScrollOutsideSearch = (event) => {
    if(this.ui.searchBar.isOpen && !this.ui.searchBar.contains(event.target)){
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }

  addEvents() {
    document.addEventListener('keydown', this.handleKeyboardEvents)
    document.addEventListener('click', this.handleClickOutside)
    document.addEventListener('scroll', this.closeAllTabs)
    this.ui.skipContentButton?.addEventListener('click', this.handleSkipContent)
    this.ui.searchBarToggle?.addEventListener('click', this.handleSearchToggle)
    this.ui.subscribeToggle?.addEventListener('click', this.handleSubscribeToggle)
    this.ui.overlay?.addEventListener('click', this.hideSearchBar)
    this.addEventListener('focusout', this.handleFocusOut)
    this.ui.navLinks.forEach(link => {
      link.addEventListener('click', this.handleNavLinkClick)
    })
  }

  removeEvents() {
    document.removeEventListener('keydown', this.handleKeyboardEvents)
    document.removeEventListener('click', this.handleClickOutside)
    document.removeEventListener('scroll', this.closeAllTabs)
    this.ui.skipContentButton.removeEventListener(
      'click',
      this.handleSkipContent
    )
    this.ui.subscribeToggle.removeEventListener(
      'click',
      this.handleSubscribeToggle
    )
    this.ui.searchBarToggle.removeEventListener(
      'click',
      this.handleSearchToggle
    )
    this.removeEventListener('focusout', this.handleFocusOut)
    this.ui.navLinks.forEach(link => {
      link.removeEventListener('click', this.handleNavLinkClick)
    })
  }

  handleNavLinkClick(e) {  
    const link = e.target.closest('a')
    const href = link.getAttribute('href')
    const isAnchor = href?.includes('#')
    const anchor = isAnchor ? '#' + href.split('#')[1] : null
    const isCurrentPage = link.pathname === window.location.pathname
    
    if (isCurrentPage && isAnchor && anchor) {
      if(!document.querySelector(anchor)){
        return
      }
      e.preventDefault()
      window.scrollTo({
        top: document.querySelector(anchor).offsetTop - 30,
        behavior: 'smooth'
      })
    }
  }

  hideNav() {
    this.ui.nav.classList.add('--hidden')
  }

  showNav() {
    this.ui.nav.classList.remove('--hidden')
  }

  showSearchBar() {
    this.ui.searchBar.animateIn()
    this.ui.container.classList.add('--search-open')
    this.classList.add('--search-open')
    this.hideNav()
    this.blockScroll()
  }
  hideSearchBar() {
    this.ui.searchBar.animateOut()
    this.ui.container.classList.remove('--search-open')
    this.classList.remove('--search-open')
    this.showNav()
    this.enableScroll()
  }

  showSubscribe() {
    this.ui.newsletterSignup.animateIn()
    this.ui.container.classList.add('--subscribe-open')
    this.classList.add('--subscribe-open')
    this.hideNav()
    this.blockScroll()
  }

  hideSubscribe() {
    this.ui.newsletterSignup.animateOut()
    this.ui.container.classList.remove('--subscribe-open')
    this.classList.remove('--subscribe-open')
    this.showNav()
    this.enableScroll()
  }

  handleSubscribeToggle(e) {
    e.preventDefault()
    if(this.ui.newsletterSignup.isOpen){
      this.hideSubscribe()
    } else{
      this.showSubscribe()
    }
  }

  handleSearchToggle(e) {
    e.preventDefault()

    if(this.ui.searchBar.isOpen){
      this.hideSearchBar()
    } else{
      this.showSearchBar()
    }
  }

  handleSkipContent(e) {
    e.preventDefault()
    document.querySelector('.page__logo').focus()
  }

  checkForSearch() {
    const urlParams = new URLSearchParams(window.location.search)
    this.onSearchPage = urlParams.has('s')
    if (this.onSearchPage) {
      const searchInput = urlParams.get('s')
      
    }
  }

  handleKeyboardEvents(e) {
    if(e.key === 'Enter' && this.ui.searchBar.isOpen){
      this.ui.searchBar.startSearch()
    }
    if (this.ui.searchBar.isOpen || this.ui.newsletterSignup.isOpen) {
      if (e.key === 'Escape') {
        this.hideSearchBar()
        this.hideSubscribe()
      }
    }
  }

  handleClickOutside(e) {
    if (!this.contains(e.target)) {
      if (this.ui.searchBar.isOpen) {
        this.hideSearchBar()
      }
      if (this.ui.newsletterSignup.isOpen) {
        this.hideSubscribe()
      }
    }
  }

  handleFocusOut(e) {
    if (!this.contains(e.relatedTarget)) {
      if (this.ui.searchBar.isOpen) {
        this.hideSearchBar()
      }
      if (this.ui.newsletterSignup.isOpen) {
        this.hideSubscribe()
      }
    }
  }
}
